import React from 'react';

function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-3xl mx-auto bg-white p-8 rounded-lg shadow-lg">
        <h1 className="text-4xl font-bold text-primary-700 mb-6 text-center">Privacy Policy </h1>
        <p className="text-gray-700 mb-4">
          This Privacy Policy describes how SwiftBidPro ("we," "us," or "our") collects, uses, and discloses your information when you use our website and services (the "Service").
        </p>

        <h2 className="text-2xl font-semibold text-primary-600 mb-3">1. Information We Collect</h2>
        <p className="text-gray-700 mb-2">
          We collect information you provide directly to us when you create an account, use our services, or communicate with us. This may include:
        </p>
        <ul className="list-disc list-inside text-gray-700 mb-4 ml-4">
          <li><strong>Account Information:</strong> Your username, email address, password, company name, company address, and company phone number.</li>
          <li><strong>Quote Data:</strong> Information related to the quotes you create, including client details, line items, pricing, and terms.</li>
          <li><strong>Communications:</strong> Records of your correspondence with us.</li>
        </ul>
        <p className="text-gray-700 mb-4">
          When you connect your Gmail account, we access your email address to facilitate sending quotes on your behalf. We do not store your Gmail password or access any other personal data from your Gmail account beyond what is necessary for the explicit functionality of sending emails through our service.
        </p>

        <h2 className="text-2xl font-semibold text-primary-600 mb-3">2. How We Use Your Information</h2>
        <p className="text-gray-700 mb-2">
          We use the information we collect to:
        </p>
        <ul className="list-disc list-inside text-gray-700 mb-4 ml-4">
          <li>Provide, maintain, and improve our Service.</li>
          <li>Process your registrations and manage your account.</li>
          <li>Enable you to create, manage, and send quotes.</li>
          <li>Communicate with you about your account and our Service.</li>
          <li>Monitor and analyze trends, usage, and activities in connection with our Service.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-primary-600 mb-3">3. Information Sharing and Disclosure</h2>
        <p className="text-gray-700 mb-2">
          We do not share, sell, or rent your personal information to third parties for their marketing purposes without your explicit consent. We may share information:
        </p>
        <ul className="list-disc list-inside text-gray-700 mb-4 ml-4">
          <li>With service providers who perform services on our behalf (e.g., hosting, analytics).</li>
          <li>To comply with legal obligations or respond to lawful requests.</li>
          <li>To protect our rights, privacy, safety, or property, and/or that of our affiliates, you, or other third parties.</li>
        </ul>

        <h2 className="text-2xl font-semibold text-primary-600 mb-3">4. Google User Data Retention and Deletion</h2>
        <p className="text-gray-700 mb-2">
          We are committed to responsible handling of Google user data. Specifically:
        </p>
        <ul className="list-disc list-inside text-gray-700 mb-4 ml-4">
          <li><strong>What we collect:</strong> When you authorize Gmail access, we securely store your Gmail access token and refresh token to enable email sending functionality.</li>
          <li><strong>Retention period:</strong> Your Gmail tokens are retained in encrypted form in our database as long as your account is active and you remain connected to Gmail.</li>
          <li><strong>Automatic deletion:</strong> When you disconnect your Gmail account from your profile settings, all associated Gmail tokens (access token and refresh token) are immediately and permanently deleted from our servers.</li>
          <li><strong>Account deletion:</strong> If you delete your account, all stored Gmail tokens and related data are permanently removed from our database.</li>
          <li><strong>No additional data stored:</strong> We do not store, cache, or retain any other data from your Google account beyond the tokens necessary for email sending.</li>
        </ul>
        <p className="text-gray-700 mb-4">
          You can verify the deletion of your Gmail connection at any time by checking your account settings—if no Gmail connection is shown, all tokens have been deleted from our systems.
        </p>

        <h2 className="text-2xl font-semibold text-primary-600 mb-3">5. Data Security</h2>
        <p className="text-gray-700 mb-4">
          We implement reasonable measures to protect your information from unauthorized access, use, or disclosure. Gmail tokens are encrypted at rest in our database. However, no internet transmission is entirely secure, and we cannot guarantee the absolute security of your data.
        </p>

        <h2 className="text-2xl font-semibold text-primary-600 mb-3">6. Your Choices</h2>
        <p className="text-gray-700 mb-4">
          You may update or correct your account information at any time by logging into your account settings. You can also disconnect your Gmail account from your profile settings, which will immediately delete all associated tokens from our servers.
        </p>

        <h2 className="text-2xl font-semibold text-primary-600 mb-3">7. Changes to This Privacy Policy</h2>
        <p className="text-gray-700 mb-4">
          We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. You are advised to review this Privacy Policy periodically for any changes.
        </p>

        <h2 className="text-2xl font-semibold text-primary-600 mb-3">8. Contact Us</h2>
        <p className="text-gray-700 mb-4">
          If you have any questions about this Privacy Policy, please contact us at Nicholasnagle9@gmail.com.
        </p>

        <p className="text-gray-500 text-sm text-center mt-8">
          Last updated: November 14, 2025
        </p>
      </div>
    </div>
  );
}

export default PrivacyPolicyPage;
